//React Components and Hooks
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
//Material UI Components and Functions
import AppBar from "@mui/material/AppBar";
import Snackbar from "@mui/material/Snackbar";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import clsx from 'clsx';

import {
  DataGridPro,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import MuiAlert from "@mui/material/Alert";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import moment from "moment"
import {
  fetchPreviousLockboxUploads,
  handleError,
  handleLockboxsUploadSubmission,
  receivedReadingsSubmission,
} from "../../modules/lockbox-uploads/api/actions";
import { Card } from '@mui/material';
import CountUp from 'react-countup';
import { setSnackbar } from "modules/snackbar/api/snackbar";
import csvToArray from "./helpers/csvToArray";
import _ from "lodash"
import "./index.css";
import UploadsTable from "./UploadsTable";
import { styled } from '@mui/material/styles';
import LocalTable from "../Manage/LocalTable"

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// Safe Transition component that doesn't access scrollTop
// This prevents errors when the container becomes null during dialog unmount
const SafeTransition = React.forwardRef(function SafeTransition(props, ref) {
  const { in: inProp, children } = props;
  
  // Simple fade-in without accessing scrollTop
  const [opacity, setOpacity] = useState(0);
  
  useEffect(() => {
    if (inProp) {
      // Use requestAnimationFrame to avoid accessing scrollTop
      requestAnimationFrame(() => {
        setOpacity(1);
      });
    } else {
      setOpacity(0);
    }
  }, [inProp]);
  
  return (
    <div
      ref={ref}
      style={{
        opacity: opacity,
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      }}
    >
      {children}
    </div>
  );
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={3} pl={-1}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}


function csvJSON(csv){

  let data = csv.trim()

  var lines=data.split("\n");

  var result = [];

  var headers=lines[0].split(",");

  for(var i=1;i<lines.length;i++){

	  var obj = {};
	  var currentline=lines[i].split(",");

	  for(var j=0;j<headers.length;j++){
		  obj[headers[j]] = currentline[j];
	  }

	  result.push(obj);

  }
  
  //return result; //JavaScript object
  return result //JSON
}

const useStyles = makeStyles({});

const Input = styled('input')({
  display: 'none',
});

const LockboxUpload = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [value, setValue] = useState(0);
  const [file, setFile] = useState({});
  const [csvData, setCsvData] = useState({ rows: [], columns: [] });
  const [successState, setSuccessState] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0.00)
  const [loading, setLoading] = useState(false)

  const getUploads = () => {
    try {
      //props.fetchPreviousLockboxUploads();
    } catch (err) {
      props.handleError(err);
    }
  };
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSuccess = () => {
    setSuccessState(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSuccessState(false);
    props.handleError(null); // Clear error in Redux
  };

  const fileInputChange = (e) => {
    let fileTypeRegEx = /(?:\.([^.]+))?$/;
    let fileType = fileTypeRegEx.exec(e.target.files[0].name)[1];

    if (fileType !== "txt") {
      props.handleError({ message: "Please upload a txt file." });
    } else {
      setFile(e.target.files[0])
      var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          // The file's text will be printed here
          let final = "R,ignore1,AccountNumber,PaymentDate,Month,CheckNumber,ignore2,Amount,PaymentType,Fee\n" + e.target.result;
          console.log(final)
          let result = csvJSON(final)
          let formatted = []
          formatted = formatData(result, true);
          console.log(formatted)
          
          setCsvData(formatted);
        };

        reader.readAsText(file);
    };
  };

  const submitReadingsUpload = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    setLoading(true);
    reader.onload = async function (evt) {
      
      try {
        // props.receivedReadingsSubmission(data); // if we implement preview feature
        for(let row of csvData.rows) {
          let result = await props.handleLockboxsUploadSubmission(
            [row],
            [row.AccountNumber]
          );
          if (result?.error == true) {
            console.log(apiRef.current)
            row.Uploaded = result.message || "Error"
            setCsvData({ ...csvData, rows: [...csvData.rows] })
            // The API action already dispatches HANDLE_ERROR, so error is already in Redux
          }
          else {
            handleSuccess();
            row.Uploaded = "Successful"
            setCsvData({ ...csvData, rows: [...csvData.rows] })
          }
        }
        
      } catch (err) {
        props.handleError(err);
      }
    };
    setLoading(false);
    reader.readAsText(file);
  };

  useEffect(() => {
    getUploads();
  }, []);

  useEffect(() => {
    console.log(csvData)
  }, [csvData]);

  const formatData = (datas, caseChange) => {
    const keys = Object.keys(datas[0]);
    keys.push("Uploaded")
    let output = keys.map((key) => {

      if(key == "Uploaded") {
        
      }

      return {
        field: key,
        editable: false,
        hide:   key == "ignore1" ||
        key == "ignore2" ||
        key == "R" || key == "Month",
        width: 200,
        headerName: (caseChange) ? _.startCase(key) : key,
        cellClassName: (params) => {
          if (params.value == null) {
            return '';
          }
    
          return clsx('super-app', {
            negative: params.value.includes("Success"),
            positive: params.value.includes("Error"),
          });
        }
      };
      


    });



    let checksTotal = 0;
    let accountNumList = [];
    datas.forEach(function (element, index) {
      delete element.ignore1;
      delete element.ignore2;
      delete element.month;

      accountNumList.push(element.AccountNumber);
      element.PaymentDate = moment.utc(element.PaymentDate, 'YYMMDD').utc().subtract(moment().utcOffset(), "m").format("YYYY-MM-DD HH:mm:ss");
      checksTotal += Number(element.Amount);
      element.id = index + 1;
    });

    setTotalAmount(checksTotal)
    return { rows: datas, columns: output };
  };

  

  // Handle page leave warning when uploads are in progress
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (props.lockBoxUpload.isLoading == true) {
        e.preventDefault();
        e.returnValue = "Attention! Uploads have not finished. Please do not navigate away from page.";
        return "Attention! Uploads have not finished. Please do not navigate away from page.";
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [props.lockBoxUpload.isLoading]);

  // Get error message from Redux state
  const displayErrorMessage = props.lockBoxUpload.error?.message || 
    (props.lockBoxUpload.error?.data?.message) ||
    "An error occurred";

  return (
    <Box className={classes.root} sx={{ width: '100%' }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={successState}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionComponent={SafeTransition}
      >
        <Alert onClose={handleClose} severity="success">
          Successfully submitted lockbox upload.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!!props.lockBoxUpload.error}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionComponent={SafeTransition}
      >
        <Alert onClose={handleClose} severity="error">
          {displayErrorMessage}
        </Alert>
      </Snackbar>

      <AppBar position="static" color="primary">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="lockbox tabs"
          sx={{
            '& .MuiTab-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                color: 'rgba(255, 255, 255, 0.9)'
              },
              '&.Mui-selected': {
                color: '#ffffff',
                fontWeight: 600
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#d67104',
              height: 3
            }
          }}
        >
          <Tab label="Upload Lockbox" {...a11yProps(0)} />
          <Tab label="Previous Lockbox Uploads" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ width: '100%' }}>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <form method="post" action="#" id="#">
              <div className="meter-readings-upload-form-container">
                <div className="meter-readings-upload-form">

                <input
                className={classes.input}
                style={{ display: 'none' }}
                onChange={fileInputChange}
                id="raised-button-file"
                multiple=""
                type="file"
              />
               <Card className="p-3 mb-4">
                  <div className="text-black-50 pb-2">Checks Total</div>
                  <div className="d-flex justify-content-between align-items-end">
                    <h3 className="display-4 mb-0 text-black">
                      <small className="pr-1 text-black-50">$</small>
                      <span className="text-success">
                        <CountUp
                          start={0}
                          end={totalAmount}
                          duration={3}
                          deplay={2}
                          separator=""
                          decimals={2}
                          decimal="."
                        />
                      </span>
                    </h3>
                  </div>
                </Card>
              <label htmlFor="raised-button-file">
                <Button color="primary" variant="contained" component="span">
                  Upload
                </Button>
              </label> 
                </div>
                {csvData.rows.length > 0 &&
                <Button
                  classes={classes.root}
                  disabled={
                    props.lockBoxUpload.isLoading
                  }
                  variant="contained"
                  color="secondary"
                  onClick={submitReadingsUpload}
                >
                  {props.lockBoxUpload.isLoading  ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    "Submit"
                  )}
                </Button> }
              </div>
            </form>

            <div style={{ height: 850, width: "100%" }}>            
            <DataGridPro
                rows={csvData.rows}
                columns={csvData.columns.length > 0 ? csvData.columns : [{ field: "id", headerName: "ID", width: 100 }]}
                rowHeight={38}
                apiRef={apiRef}
                showToolbar
                slotProps={{
                  toolbar: {
                    csvOptions: {
                      getRowsToExport: () => csvData.rows.map((r) => r.id),
                      fileName: "lockbox-upload",
                      utf8WithBom: true,
                    },
                    printOptions: {
                      getRowsToExport: () => csvData.rows.map((r) => r.id),
                    },
                  },
                }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      id: false,
                      R: false,
                      ignore1: false,
                      ignore2: false
                    },
                  },
                }}
                sx={{
                  width: '100%',
                  '& .super-app-theme--cell': {
                    backgroundColor: 'rgba(224, 183, 60, 0.55)',
                    color: '#1a3e72',
                    fontWeight: '600',
                  },
                  '& .super-app.negative': {
                    backgroundColor: 'rgba(157, 255, 118, 0.49)',
                    color: '#1a3e72',
                    fontWeight: '600',
                  },
                  '& .super-app.positive': {
                    backgroundColor: '#d47483',
                    color: '#1a3e72',
                    fontWeight: '600',
                  },
                }}
                />
            </div>
          </TabPanel>
        </Box>

        <Box>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <UploadsTable
              uploads={
                props.lockBoxUpload.data.previousLockboxUploads
              }
            />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    lockBoxUpload: state.lockBoxUpload,
  };
};

export default connect(mapStateToProps, {
  handleLockboxsUploadSubmission,
  receivedReadingsSubmission,
  handleError,
  fetchPreviousLockboxUploads,
})(LockboxUpload);
